<template>
  <div class="p-2 d-flex flex-column justify-content-center align-items-center">
    <b-row
      class="w-100"
      style="position: relative"
    >
      <b-col md="12">
        <b-card
          title="Resumo"
          class="w-100 h-auto"
        >
          <div>
            <e-pay-box-sale-item-table
              class="bordered"
              :table-items="getItems"
              show-img
              item-read-only
              prices-to-right
              :show-number="false"
            />
          </div>

          <div class="mt-1">
            <div class="d-flex justify-content-between mb-1">
              <p class="h5 mb-0 text-muted">
                Subtotal:
              </p>
              <p class="h5 mb-0 text-muted">
                {{ getSubtotalSale | currency }}
              </p>
            </div>
            <div
              v-if="hasRewardsApplied"
              class="d-flex justify-content-between mb-1"
            >
              <p class="h5 mb-0 text-success">
                Desconto ecash:
              </p>
              <p class="h5 mb-0 text-success">
                -{{ getRewardsAmountUsed | currency }}
              </p>
            </div>
            <div class="d-flex justify-content-between border-top pt-2">
              <p class="h3 mb-0 font-weight-bold">
                Total:
              </p>
              <p class="h3 mb-0 font-weight-bold">
                {{ getTotalSale | currency }}
              </p>
            </div>
          </div>
        </b-card>
      </b-col>

      <b-col
        md="12"
        class="payment-options-container"
      >
        <b-card
          :title="$t('Escolha a forma de pagamento')"
          class="mb-1"
        >
          <b-row
            style="row-gap: 10px"
            class="mb-1"
          >
            <b-col
              v-for="item in paymentMethodsInAtm"
              :key="item.id"
              md="4"
            >
              <e-button-card
                :id="`atm_payment-method_btn-${item.id}`"
                icon-component="BIcon"
                :icon="getIconByPaymentMethod[item.method]"
                :text-title="item.name"
                @click="onShowModalValue(item)"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col
              v-if="hasCanceledTefPixPayment"
              md="12"
            >
              <b-alert
                show
                variant="danger"
                class="p-2"
              >
                {{ $t('PAY_BOX_SALE.TEF.ATM.INSTRUCTION_TEF_CANCEL_PIX') }}
              </b-alert>
            </b-col>

            <b-col
              v-if="hasGenericTefTransactionFailed"
              md="12"
            >
              <b-alert
                show
                variant="danger"
                class="p-2"
              >
                {{ $t('PAY_BOX_SALE.TEF.ATM.ERROR_TRANSACTION_FAILED') }}
              </b-alert>
            </b-col>

            <b-col md="12">
              <method-line
                v-for="(receipt, index) in paymentForm.receipts"
                :id="`atm_payment-method_item-${index}`"
                :key="index"
                :receipt="receipt"
                :value="receipt.value"
                :is-cancelled="receipt.canceled"
                :show-btn-canceled="showCancelBtn(receipt)"
                class="rounded"
                is-atm
                @click-delete="onDeleteMethodPayment(index)"
                @click-print="stPrintReceipt({ index })"
                @click-check-payment="onCheckPaymentStatus(index)"
                @click-confirm-payment="onShowPaymentConfirm(receipt)"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <modal-value
      ref="modalValue"
      :sale-uuid="currentSaleUuid"
      :balance-value="paymentForm.balance"
      :btn-confirm-busy="waitPeripheral"
      is-atm
      @click-confirm="onStartFinishFlow"
    />

    <modal-manual-payment-confirm
      ref="modalPaymentConfirm"
      @click-confirm="onManualConfirmPayment"
    />

    <modal-cold-option ref="atmModalColdOption" />

    <atm-modal-installment ref="atmModalInstallment" />
  </div>
</template>

<script>
import EButtonCard from '@/views/components/EButtonCard.vue'
import EPayBoxSaleItemTable from '@/views/components/tables/EPayBoxSaleItemTable.vue'
import { BRow, BCol, BAlert, BCard } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { paymentTypes, payBoxPayments, payBoxTypes, loadingOverlay, saleDomain } from '@/mixins'
import { isTefCard, isTefPix } from '@/store/utils/paybox/paybox-payments'
import delegablePermissions from '@/utils/delegable-permissions'
import ModalValue from '../pay-box/components/tabs/components/ModalValue.vue'
import MethodLine from '../pay-box/components/tabs/components/MethodLine.vue'
import ModalManualPaymentConfirm from '../pay-box/components/tabs/components/ModalManualPaymentConfirm.vue'
import ModalColdOption from '../pay-box/components/modals/ModalColdOption.vue'
import AtmModalInstallment, {
  INSTALLMENT_SELECTION_CANCELLED,
} from './components/modals/AtmModalInstallment.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    EButtonCard,
    BCard,
    EPayBoxSaleItemTable,
    ModalValue,
    MethodLine,
    ModalManualPaymentConfirm,
    ModalColdOption,
    AtmModalInstallment,
  },

  mixins: [paymentTypes, payBoxTypes, payBoxPayments, loadingOverlay, saleDomain],

  data() {
    return {
      waitPeripheral: false,
      userDelegatedPixConfirmation: null,
    }
  },

  computed: {
    ...mapState('app', ['modalAuthRef']),

    ...mapState('pages/pdv', ['paymentMethodsInAtm']),

    ...mapState('pages/pdv/payBox', ['paymentForm', 'items', 'coldOption']),
    ...mapGetters('pages/pdv/payBox', [
      'getItems',
      'getTotalSale',
      'getSubtotalSale',
      'hasRewardsApplied',
      'getRewardsAmountUsed',
      'currentSaleUuid',
      'hasCanceledTefPixPayment',
      'hasGenericTefTransactionFailed',
      'hasColdOptionProducts',
    ]),
    ...mapGetters('pages/pdv/payBoxConfiguration', ['isKioskStore']),

    getIconByPaymentMethod() {
      return {
        None: 'currency-dollar',
        CreditCard: 'credit-card',
        DebitCard: 'credit-card',
        Pix: 'x-diamond-fill',
        Cash: 'cash',
      }
    },
  },

  methods: {
    ...mapActions('pages/pdv/atm', {
      stCleanAtmState: 'cleanState',
    }),
    ...mapActions('pages/pdv/atm/status', {
      stSetIsPaymentError: 'setIsPaymentError',
      stSetIsFinishError: 'setIsFinishError',
    }),
    ...mapActions('pages/pdv/atm/catalog', {
      stSetFiltersAndSearch: 'setFiltersAndSearch',
    }),

    ...mapActions('pages/pdv/payBox', {
      stAddReceipt: 'addReceipt',
      stConfirmReceipt: 'confirmReceipt',
      stRemoveReceipt: 'removeReceipt',
      stPrintReceipt: 'printReceipt',
      stValidatePayBoxActionIsBlocked: 'validatePayBoxActionIsBlocked',

      stCleanPayBoxState: 'cleanState',
      stFinishSale: 'finishSale',
      stValidateFinishSale: 'validateFinishSale',
      stValidateAddReceipt: 'validateAddReceipt',
      stSetColdOption: 'setColdOption',
    }),

    showCancelBtn(item) {
      if (item.id) return false
      return true
    },

    async onShowModalValue(paymentMethod) {
      if (await this.mxPayBoxActionIsBlocked(this.uiPayBoxActionsEnum.PAYMENT_ADD)) {
        return
      }

      const error = await this.stValidateAddReceipt()

      if (error.message) {
        this.showAtmAlert({
          icon: 'warning',
          title: this.$t(error.title),
          text: this.$t(error.message),
        })
        return
      }

      // O estado dos produtos (No gelo, Gelado ou Natural) deve ser escolhido
      // assim que o método de pagamento é selecionado, ANTES de abrir o fluxo de
      // valor/integração com o pinpad. Resolve apenas uma vez por venda e
      // persiste no store para ser reutilizado na finalização.
      await this.resolveColdOptionBeforePayment()

      const installmentOption = await this.resolveInstallmentBeforePayment(paymentMethod)

      // O cliente desistiu na tela de parcelamento: volta para a escolha da forma de pagamento,
      // sem acionar o pinpad. Nada foi cobrado, então não há o que desfazer.
      if (installmentOption === INSTALLMENT_SELECTION_CANCELLED) {
        return
      }

      try {
        await this.$refs.modalValue.payOnAtm(paymentMethod, installmentOption)
      } catch {
        this.stSetIsPaymentError(true)
      }
    },

    /**
     * Pergunta ao cliente em quantas vezes pagar, antes de acionar o pinpad.
     *
     * Só no crédito: débito e PIX não parcelam. A pergunta vem antes da transação porque no TEF
     * a quantidade de parcelas vai no comando enviado à adquirente — depois de autorizada, não
     * há mais o que escolher.
     *
     * A própria modal decide se aparece: sem política aplicável para o valor, ela devolve nulo
     * sem exibir nada e o pagamento segue à vista, como sempre foi.
     */
    async resolveInstallmentBeforePayment(paymentMethod) {
      if (paymentMethod?.method !== this.paymentTypeEnum.CREDIT_CARD) {
        return null
      }

      return this.$refs.atmModalInstallment.showModal(this.paymentForm.balance)
    },

    async onStartFinishFlow(value) {
      const isSuccess = await this.onAddMethodPayment(value)

      if (!isSuccess) {
        this.stSetIsFinishError(true)
        return
      }

      this.$emit('finish-sale')
    },

    async resolveColdOptionBeforePayment() {
      if (this.coldOption) {
        return this.coldOption
      }

      if (this.hasColdOptionProducts && !this.isKioskStore) {
        const selectedColdOption = await this.$refs.atmModalColdOption.showModal()
        this.stSetColdOption(selectedColdOption)
        return selectedColdOption
      }

      return null
    },

    async onAddMethodPayment(value) {
      try {
        this.waitPeripheral = true

        // No ATM, o comprovante do pagamento (TEF) NÃO é impresso no momento do
        // recebimento. Ele é o último documento impresso, ao final da venda (ver
        // a action `finishSale` no store), após o cupom fiscal e o recibo de retirada.
        await this.stAddReceipt(value)
      } catch (error) {
        this.showError({ error, message: 'Erro ao adicionar pagamento' })
      } finally {
        this.waitPeripheral = false
      }

      if (this.mxIsToCheckPixStatus(value)) {
        await this.onCheckPaymentStatus(this.paymentForm.receipts.length - 1)
      }

      return true
    },

    async onDeleteMethodPayment(index) {
      try {
        // const isBlocked = await this.stValidatePayBoxActionIsBlocked({
        //   action: this.uiPayBoxActionsEnum.PAYMENT_REMOVE,
        // })
        // if (isBlocked) {
        //   this.showWarning({ message: this.$t('Ação bloqueada no momento.') })
        //   return
        // }

        const confirmOptions = {
          text: this.$t('Deseja realmente cancelar este recebimento ?'),
          focusCancel: true,
        }

        const receipt = this.paymentForm.receipts[index]

        if (isTefPix(receipt)) {
          confirmOptions.text = this.$t('PAY_BOX_SALE.TEF.ATM.CONFIRMATION_TEF_CANCEL_PIX')
        }

        const confirm = await this.confirm(confirmOptions)
        if (confirm) {
          const tefPaymentCancelation = await this.cancelTefPayment(receipt)
          if (tefPaymentCancelation || !isTefCard(receipt)) {
            this.stRemoveReceipt({ index, tefPaymentCancelation })
          }
        }
      } catch (error) {
        this.showError({ error })
      }
    },

    async onShowPaymentConfirm(receipt) {
      this.userDelegatedPixConfirmation = await this.modalAuthRef.auth(
        delegablePermissions.PDV_PIX_MANUAL_CONFIRMATION
      )

      this.$refs.modalPaymentConfirm.showModal(receipt)
    },
    async onManualConfirmPayment(receipt, confirmData) {
      try {
        this.waitPeripheral = true

        this.stConfirmReceipt({
          receipt,
          confirmData: {
            ...confirmData,
            confirmationActionType: this.paymentActionTypeEnum.MANUAL,
          },
          userDelegated: this.userDelegatedPixConfirmation,
        })
        // O comprovante é impresso ao final da venda (ver finishSale no store).
      } catch (error) {
        this.showError({ error, message: 'Erro ao confirmar pagamento' })
      } finally {
        this.waitPeripheral = false
      }
    },

    async onCheckPaymentStatus(index) {
      try {
        const receipt = this.paymentForm.receipts[index]

        this.waitPeripheral = true

        const tefResult = await this.pixCheckStatus(receipt, this.currentSaleUuid)

        if (!tefResult) {
          return
        }

        if (tefResult?.transactionFailed) {
          await this.showAtmAlert({
            title: this.$t('PAY_BOX_SALE.TEF.ATM.PIX_CHECK_STATUS_TRANSACTION_FAILED'),
            icon: 'warning',
          })
          return
        }

        if (tefResult?.paymentApproved) {
          await this.stConfirmReceipt({
            receipt,
            confirmData: {
              tefPayment: tefResult,
              confirmationActionType: this.paymentActionTypeEnum.PIN_PAD,
            },
          })
          // O comprovante é impresso ao final da venda (ver finishSale no store).
        } else {
          await this.showAtmAlert({
            title: this.$t('Pagamento não está aprovado na adquirente.'),
            icon: 'warning',
          })
        }
      } catch (error) {
        await this.showAtmAlert({
          error,
          title: 'Não foi possível realizar a consulta',
          icon: 'error',
          confirmButtonText: this.$t('Voltar'),
          timer: null,
        })
      } finally {
        this.waitPeripheral = false
      }
    },
  },
}
</script>

<style scoped>
.dots-line {
  width: 100%;
  border-bottom: 1px dotted black;
  margin-bottom: 5px;
}

.payment-options-container {
  position: sticky;
  bottom: 0;
  right: 0;
}
</style>
